import { getPage, getDisclaimer } from '../actions/pages';

const initialState = {
  data: {},
  loading: false,
  error: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case getPage.REQUEST:
      return { ...state, loading: true, error: null };

    case getPage.SUCCESS:
    case getDisclaimer.SUCCESS: {
      const { locale, slug, page } = action.payload;
      // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      return { ...state, data: { ...state.data, [locale]: { ...state.data[locale], [slug]: page } } };
    }

    case getPage.FAILURE:
      return { ...state, error: action.payload };

    case getPage.FULFILL:
      return { ...state, loading: false };

    default:
      return state;
  }
};
